import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';  // Actualización aquí
import { ActivatedRoute } from '@angular/router';
import { EncuestaService } from 'src/app/services/encuesta.service';
import { ReportingService } from 'src/app/services/reporting.service';
import { MessageBoxComponent } from '../message-box/message-box.component';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
// s


@Component({
    selector: 'app-print-encuesta',
    templateUrl: './print-encuesta.component.html',
    styleUrls: ['./print-encuesta.component.scss'],
    standalone: false
})
export class PrintEncuestaComponent implements OnInit {
  mensajeExito = "Gracias por el tiempo que has tomado para contestar nuestras preguntas, tus datos han sido guardados correctamente, ya pudes cerrar esta ventana.";
  mensajeError = "Lo sentimos, no pudimos localizar la encuesta a la cual estas intentado acceder, por favor revisa tu token e intenta nuevamente.";
  tituloExito = "Encuesta envíada";
  tituloError = "Error";
  erroricon = "error";
  exitoicon = "send";

  response:string;
  nombreEncuesta;
  subtituloEncuesta;
  pregunta:any;
  index = 0;
  respuestas = [];
  resultado:any;
  texto:string;
  userResponse = [];
  code = 0;
  

  constructor(
    private _reportingService:ReportingService,
    private _encuestaService:EncuestaService,
    private dialog:MatDialog,
    public dialogRef: MatDialogRef<PrintEncuestaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    
  ) { }

  ngOnInit(): void {
    let id = this.data.id;
    //console.info("idAplicacion " + this.data.idAplicacion);
    if(this.data.excel){
      console.log('excel');
      this._reportingService.getReportEncuesta(this.data.idAplicacion).subscribe(result=>{
        // console.info(result);
        console.log("result: ",result);
        this.code=result.code;
        if(result.code == 200){
          //this.resultado = result.datos;
          this.postExcelReporteEncuestas( {datos: result.datos} );
        }else{
          //this.openDialog(this.tituloError,this.mensajeError,this.erroricon);
        }
      },error=>{
        
        console.info(error);
      });
    }else if(this.data.idAplicacion){
      console.warn("> Reporting");
      this._reportingService.getReportEncuesta(this.data.idAplicacion).subscribe(result=>{
        // console.info(result);
        console.log("result: ",result);
        this.code=result.code;
        if(result.code == 200){
          this.resultado = result.datos;
          this.iniciarEncuesta(result.datos);
        }else{
          //this.openDialog(this.tituloError,this.mensajeError,this.erroricon);
        }
      },error=>{
        console.info(error);
      })
    }else if(id){
      
      this._encuestaService.getEncuestaById(id).subscribe(result=>{
        console.info(result);
        this.code=result.code;
        if(result.code == 200){
          this.resultado = result.datos;
          this.nombreEncuesta = result.datos.encuesta.nombre;
          this.subtituloEncuesta = result.datos.encuesta.descripcion;
          //this.iniciarEncuesta(result.datos);
        }else{
          //this.openDialog(this.tituloError,this.mensajeError,this.erroricon);
        }
      },error=>{
        console.info(error);
      })
    }
  }

  iniciarEncuesta(datos){
    console.log("iniciarEncuesta datos: ", datos);
    // this.nombreEncuesta = datos.encuesta.nombre;
    this.nombreEncuesta = datos[0].nombre;
    // this.nombreEncuesta = datos.encuesta.descripcion;
    this.subtituloEncuesta = datos[0].descripcion;
 
    
  }
  getRespuestasByPregunta(id,respuestas:any){
    let preguntas = [];
    for(let i=0; i<respuestas.length; i++){
      if(respuestas[i].id_pregunta_fk == id){
        preguntas.push(respuestas[i]);
      }
    }
    console.log("preguntas: ",preguntas);
    return preguntas;
  }
  openDialog(title,text,icon) {
    this.dialog.open(MessageBoxComponent,{ disableClose: true ,data: {title: title, text: text, icon:icon, href: "/login/encuesta"}});
  }
  redondear(num:number){
    return Math.round(num);
  }

  getRespuestas(id_pregunta_pk):Array<any>{
    return this.getRespuestasByPregunta(id_pregunta_pk,this.resultado.respuestas);
  }

  imprimir(){
    // console.log("va a imprimir:", document.getElementById('areaImprimir').innerHTML);
    let head = "<html><header>"
  
    let css = '<style>.percentage{font-size:.8em;line-height:1;text-transform:uppercase;width:100%;height:40px;margin-left:130px;background:repeating-linear-gradient(to right,#ddd,#ddd 1px,#fff 1px,#fff 5%) !important} .mat-radio-button.mat-radio-disabled .mat-radio-label-content {width: 95%;}.text{font-weight:600;display:flex;align-items:center;height:40px;width:100%px;background-color:#fff;position:absolute;left:0;justify-content:flex-end}html,body{height:500px;font-family:"fira-sans-2",sans-serif;color:#333}.example-radio-group {margin: 15px 0;}.example-radio-button {margin: 5px;}textarea{width:100%; height:90px} .mat-radio-container,.mat-radio-label-content{float:left;display:inline;}table {border-collapse: collapse;border-spacing: 0;width: 100%;border: 1px solid #ddd; margin-bottom: 10px;}th, td {text-align: left;padding: 16px;border: 1px solid #ddd;}tr:nth-child(even) {background-color: #f2f2f2;}</style>';
    
    var WinPrint = window.open('', 'Impresión de reporte', 'width=800,height=650,scrollbars=1,menuBar=1');
    var str =  head + css +"</head><body>"+ document.getElementById('areaImprimir').innerHTML + "</body></html>";
    WinPrint.document.write(str);
    WinPrint.print();
    WinPrint.close();


  
  }
  convierteNumber(cadena:String){
    return Number(cadena);
  }

  convierteEntero(cadena:String){
    var x = cadena;
    var y: number = +x;
    return y;
  }

  convierteEnteroFinal(cadena:any){
    var x = cadena;
    var y: Number = Math.round(cadena);
    return y;
  }



  public async postExcelReporteEncuestas(data: any){
    this._reportingService.postExcelReporteEncuestas(data).subscribe((result: any)=>{
      // console.info(result);
      console.log("result: ",result);
     

    },async error=>{
      if(this.data.excel){
        console.log('aqui');
        //this.exportToExcel(error?.error?.text, 'ReporteExcel');
       
let errorText = error.error.text;








      }
      console.info(error);
    })
  }


  // public async exportToExcel(html: string, fileName: string): Promise<void> {
    
  //   const table = document.createElement('table');
  //   table.innerHTML = html;
  //   // const workbook = new ExcelJS.Workbook();
  //   // const worksheet: ExcelJS.Worksheet = workbook.addWorksheet('Sheet1');
  //   const rows = table.querySelectorAll('tr');
  //   rows.forEach((row, rowIndex) => {
  //     const columns = row.querySelectorAll('td, th');
  //     const rowData = [];
  
  //     // Loop over all columns in the row
  //     columns.forEach((column, columnIndex) => {
  //       rowData[columnIndex] = column.textContent;
  //     });
  
  //     // Add the row data to the worksheet
  //     //worksheet.addRow(rowData);
  
  //     // Set styles for the row
  //     const style = { font: { bold: true, size: 5 } };
  //     if (rowIndex > 0) { // skip header row
  //       //worksheet.getRow(rowIndex + 1).eachCell((cell) => {
  //         cell.style = style;
  //       });
  //     }

      
  //   });



    
  
  //   // Adjust column widths to content
  //   worksheet.columns.forEach((column, index) => {
  //     let maxLength = 0;
  //     const columnData = worksheet.getColumn(index + 1).values;
  //     columnData.forEach((value) => {
  //       //const length = Math.ceil(worksheet.workbook.sharedStrings.get(value).length * 1.1);
  //       //if (length > maxLength) {
  //         maxLength = 20;
  //       //}
  //     });
  //     column.width = maxLength + 2;
  //   });

   
  
  //   const excelBuffer: any = await workbook.xlsx.writeBuffer();
  //   this.saveAsExcelFileYucatan(excelBuffer, fileName);
  // }
  
  // saveAsExcelFileYucatan(buffer: ArrayBuffer, fileName: string): void {
  //   const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //   const url: string = window.URL.createObjectURL(data);
  //   const link: HTMLAnchorElement = document.createElement('a');
  //   link.href = url;
  //   link.download = fileName + '.xlsx';
  //   link.click();
  // }
  
  
  
  


  /*public exportToExcel(html: string, fileName: string): void {
    const table = document.createElement('table');
    table.innerHTML = html;
    html2xlsx(table.outerHTML, {fileName: fileName});
  }*/
  

}
